<template>
  <div>
    <div v-for="(item, index) in issue.items" :key="item.id" class="mb-3 last:mb-0">
      <total-item :disabled="view" :issue="issue" :item="itemModel(item)" />
    </div>
    <div v-if="issue.showSum" class="mt-5">加总值：{{ sum }}</div>
  </div>
</template>

<script>
import TotalItem from '@/questions/components/TotalItem'

export default {
  name: 'Total',
  components: { TotalItem },
  changeExpr: "sum",
  computed: {
    sum() {
      return this.issue.getSum()
    }
  },
  methods: {
    itemModel(item) {
      return {...item, value: +item.value}
    }
  }
}
</script>
